
export const NoDataFound = ({ data }: { data: any }) => {
    return (
        <>
            {data?.length === 0 && (
                <div
                    style={{
                        width: "100%",
                        textAlign: "center",
                        height: "200px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    No data found
                </div>
            )}
        </>
    );
};